import tool from '../../tools/tool'
import Api from '../../api/pay'

export default {
  namespace: 'payParams', // 注意定义namespace, 将会在store中存储
  state: {
    payParams: {},
    openId: '',
    // openId: '031XQnGa1agoPA0GQBFa1fTFmq3XQnGQ', // 袁杏全
    id: '',
    data: {},
    payMoney: {},
    plateNumId: '',
    payDetail: {},
    conpousSelect: [],
    conpousList: [],
    plateCarNumber: '',
    plateCarData: {},
    cashMon: '',
    temMonData: [],
    appType: 'wx',
    noPlateParams: {},
    totalAccountMoney: 0,
    applyInvoice: {},
    readySelectArr: [],
    invoiceDetailData: {},
    invoicSecondApplyData: {},
    invoiceOrderId: '',
    invoiceMoreInfo: {},
    scrollBottom: undefined, // 列表滚动的距离
    payParkId: '',
    isClickParklot: false,
    Party_C_Object: {},
    goBackStatus: false,
    parklotInfo: JSON.parse(localStorage.getItem('parklotInfo')),
    parklotInfoIsSend: false,
    goBackEvent: () => {}
  },
  getters: {
    payParams: state => state.payParams,
    openId: state => state.openId,
    id: state => state.id,
    data: state => state.data,
    payMoney: state => state.payMoney,
    plateNumId: state => state.plateNumId,
    payDetail: state => state.payDetail,
    conpousSelect: state => state.conpousSelect,
    conpousList: state => state.conpousList,
    plateCarNumber: state => state.plateCarNumber,
    plateCarData: state => state.plateCarData,
    cashMon: state => state.cashMon,
    temMonData: state => state.temMonData,
    appType: state => state.appType,
    noPlateParams: state => state.noPlateParams,
    totalAccountMoney: state => state.totalAccountMoney,
    applyInvoice: state => state.applyInvoice,
    readySelectArr: state => state.readySelectArr,
    invoiceDetailData: state => state.invoiceDetailData,
    invoicSecondApplyData: state => state.invoicSecondApplyData,
    invoiceOrderId: state => state.invoiceOrderId,
    invoiceMoreInfo: state => state.invoiceMoreInfo,
    payParkId: state => state.payParkId,
    scrollBottom: state => state.scrollBottom,
    isClickParklot: state => state.isClickParklot,
    Party_C_Object: state => state.Party_C_Object, // 与卡缴费，是否存在第三方
    goBackStatus: state => state.goBackStatus
  },
  actions: {
    // actionsOpenId({commit,state},id){
    //     commit("getOpenId",'')
    //     commit("getPayParams",{})
    //     let href = window.location.href
    //     let urlParams = href.split("#/")[1]
    //     let url="https://tcct.grgyintong.com/#/"+urlParams
    //     let appid='wxf285ea85c975a59e'
    //     // let url="https://tcc.grgyintong.com/#/"+urlParams
    //     // let appid='wxfd559cd8f44405f1' //平云广场
    //     // let appid='wx1ce3ed8c30f71b9c' //旧的开发公众号
    //     let redirectUri = encodeURIComponent(url)
    //     window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + redirectUri + '&response_type=code&scope=snsapi_userinfo#wechat_redirect'
    //     Api.authorization(code).then(res => {
    //       let appid='wxf285ea85c975a59e'
    //       let data=res.data
    //       let openId=data.openId
    //       commit("getOpenId",openId)
    //       commit("getPayParams",data)
    //       this.$wechat.config({
    //         debug: false,
    //         appId:  data.appId,
    //         timestamp: data.timestamp,
    //         nonceStr:data.nonceStr, //随机串
    //         signature: data.signature,
    //         jsApiList: ['checkJsApi', 'chooseWXPay', 'getNetworkType', 'previewImage', 'openCard',
    //           'translateVoice', 'chooseImage', 'uploadImage', 'onMenuShareTimeline','addCard','hideOptionMenu','hideMenuItems'
    //         ]
    //       })
    //       this.$wechat.ready(function () {
    //         // this.$wechat.hideOptionMenu()
    //       })
    //     }).catch(err => {
    //       console.log(`err`, err)
    //     })
    // }
  },
  mutations: {
    getPayParams (state, value) {
      state.payParams = value
    },
    getOpenId (state, value) {
      state.openId = value
    },
    getId (state, value) {
      state.id = value
    },
    getData (state, value) {
      state.data = value
    },
    getPayMoney (state, value) {
      state.payMoney = value
    },
    getParklotInfoIsSend (state, value) {
      state.parklotInfoIsSend = value
    },
    getPlateNumId (state, value) {
      state.plateNumId = value
    },
    getPayDetail (state, value) {
      state.payDetail = value
    },
    getConpousSelect (state, value) {
      state.conpousSelect = value
    },
    getConpousList (state, value) {
      state.conpousList = value
    },
    getPlateCarNumber (state, value) {
      state.plateCarNumber = value
    },
    getPlateCarData (state, value) {
      state.plateCarData = value
    },
    getCash (state, value) {
      state.cashMon = value
    },
    getTemMonData (state, value) {
      state.temMonData = value
    },
    getAppType (state, value) {
      state.appType = value
    },
    getParams (state, value) {
      state.noPlateParams = value
    },
    getParklotInfo (state, value) {
      state.parklotInfo = value
    },
    getTotalAccountMoney (state, value) {
      state.totalAccountMoney = value
    },
    getGoBackStatus (state, value) {
      state.goBackStatus = value
    },
    getGoBackEvent (state, value) {
      state.goBackEvent = () => {
        state.goBackStatus = true
      }
    },
    getApplyInvoice (state, value) {
      state.applyInvoice = value
    },
    getReadySelectArr (state, value) {
      state.readySelectArr = value
    },
    getInvoiceDetailData (state, value) {
      state.invoiceDetailData = value
    },
    getInvoicSecondApplyData (state, value) {
      state.invoicSecondApplyData = value
    },
    getInvoiceOrderId (state, value) {
      state.invoiceOrderId = value
    },
    getInvoiceMoreInfo (state, value) {
      state.invoiceMoreInfo = value
    },
    getScrollBottom (state, value) {
      state.scrollBottom = value
    },
    getPayParkId (state, value) {
      state.payParkId = value
    },
    isClickParklot (state, value) {
      state.isClickParklot = value
    },
    getPartyC_Object (state, value) {
      state.Party_C_Object = value
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/payParams.js